import React from 'react';
import {
    Popover,
    PopoverContent,
    PopoverHandler,
    Typography
} from "@material-tailwind/react";
import { Link } from 'react-router-dom'

export default function PopoverMenu({ menus = [], title = "" }) {
    const [openPopover, setOpenPopover] = React.useState(false);

    const triggers = {
        onMouseEnter: () => setOpenPopover(true),
        onMouseLeave: () => setOpenPopover(false),
    };

    return (
        <Popover open={openPopover} handler={setOpenPopover}>
            <PopoverHandler {...triggers}>
                <Typography >{title}</Typography>
            </PopoverHandler>
            <PopoverContent {...triggers} className="z-50 max-w-[35rem]">
                <div className="mb-2 flex items-center justify-between gap-4">
                    <ul className="space-y-2">
                        {
                            menus.map((m, idx) => (<li key={`${title}_menu_${idx}`}><Link to={m.link} className="cursor-text text-left text-lg">{m.name}</Link></li>))
                        }
                    </ul>
                </div>
            </PopoverContent>
        </Popover>
    );
}